import { storage } from '../firebaseApp'

class Storage {
  async saveImage(restaurantId: string, file: File) {
    const storagePathAndFilename = `restaurants/${restaurantId}/${file.name}`
    const originalRef = storage.ref(storagePathAndFilename)
    await originalRef.put(file)

    const url = await originalRef.getDownloadURL()
    return url
  }
}

export default new Storage()
